import script from "./SanctionScreeningSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SanctionScreeningSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__